<template>
  <div>
    <div class="main-container">
      <div class="container">
        <div v-if="ready" class="check-container">
          <div>
            <div class="circle-loader load-complete">
              <div class="checkmark"></div>
            </div>
            <h1>{{getMessage('TTL_LISTO')}}</h1>
            <br>
            <h2 v-if="ubicacionDisplay">{{getMessage('MSG_SERAS_LLAMADO_CONSULTORIO', [ubicacionDisplay])}}</h2>
            <h2 v-else>{{getMessage('MSG_TOME_ASIENTO')}}</h2>
          </div>
        </div>
        <h1 v-else>{{ getMessage('MSG_IMPRIMIENTO_ATENCION')}}</h1>
      </div>
    </div>
    <div v-show="false">
      <div id="printMe">
        <div
          style="
            border-style: solid;
            border-width: medium;
            width: 240px;
            height: 270px;
            text-align: center;
            page-break-before: always;
            "
            ref="divAttention"
          >
          <br />
          <p style="font-size: 14px; margin: 10px;">
            <strong>{{headerDisplay}}</strong>
          </p>
          <p style="font-size: 56px; margin: 10px;">
            <strong>{{meIdDisplay}}</strong>
          </p>
          <p style="font-size: 12px; margin: 10px;">{{getMessage('MSG_SERAS_LLAMADO_CONSULTORIO', [ubicacionDisplay])}}</p>
          <br />
          <p style="font-size: 12px; margin: 10px;">{{dateDisplay}}</p>
          <p style="font-size: 12px; margin: 10px; ">{{footerDisplay}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
let ipcRenderer
if (typeof process !== 'undefined' && process.type === 'renderer') {
  const { ipcRenderer: electronIpcRenderer } = require('electron')
  ipcRenderer = electronIpcRenderer
}

export default {
  props: {
    meId: {
      type: Number
    },
    date: {
      type: String
    },
    header: {
      type: String
    },
    footer: {
      type: String
    },
    consultorioSala: {
      type: String, default: ''
    },
    mustPay: {
      type: Boolean
    }
  },
  data () {
    return {
      ready: false,
      meIdDisplay: this.meId.toString(),
      dateDisplay: this.date,
      headerDisplay: this.header,
      footerDisplay: this.footer,
      ubicacionDisplay: this.consultorioSala
    }
  },
  mounted: function () {
    this.printAttention()
  },
  computed: {
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  methods: {
    ...mapActions('Appointment', ['generarNumeroRecepcion']),
    printAttention () {
      this.meIdDisplay = this.meId.toString()
      this.dateDisplay = this.date
      this.headerDisplay = this.header
      this.footerDisplay = this.footer
      this.ubicacionDisplay = this.consultorioSala
      this.$nextTick(() => {
        this.print()
      })
    },
    ipcPrint () {
      if (!ipcRenderer) return
      const content = this.$refs.divAttention.outerHTML
      ipcRenderer.send('app:print', content)
    },
    print: function () {
      var vm = this
      vm.ipcPrint()
      if (vm.mustPay) {
        setTimeout(function () {
          vm.$router.push({
            name: 'messageScreen',
            params: {
              message: vm.getMessage('MSG_COSEGURO_PENDIENTE'),
              showReady: true
            }
          })
        }, 1500)
      } else {
        vm.ready = true
        setTimeout(function () {
          vm.$router.push({ name: 'TotemHome' })
        }, 8000)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
.check-container {
  text-align: center;
  width: 60%;
}
.checkmark {
  display: inline-block;
  margin-top: 20px;
}
.checkmark:after {
  content: "";
  display: block;
  width: 20px;
  height: 50px;
  border: solid #00838f;
  border-width: 0 10px 10px 0;
  transform: rotate(45deg);
}

.circle-loader {
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-left-color: #00838f;
  animation: loader-spin 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 7em;
  height: 7em;
  text-align: center;
}

.load-complete {
  -webkit-animation: none;
  animation: none;
  border-color: #00838f;
  transition: border 500ms ease-out;
}
</style>
